<template>
  <Modal
    ref="modal"
    width="620px"
    class="calculation-modal"
  >
    <template #header>
      <p class="bold has-text-size-18 m-0">
        {{ $t("bnpl:customer_limit.calculation.title") }}
      </p>
    </template>
    <template #default="{ close }">
      <div class="flex-column gap-20">
        <div class="flex-column gap-16">
          <div
            v-for="item in items"
            :key="item.token"
            class="calculation-item"
          >
            <font-awesome-icon
              class="calculation-icon"
              :icon="['fas', item.icon]"
            />
            <p>{{ $t(item.token) }}</p>
          </div>
        </div>
        <p class="has-text-size-12 has-text-grey">
          {{ $t("bnpl:customer_limit.calculation.disclaimer") }}
        </p>
        <button
          class="btn btnL stretch"
          @click="close"
        >
          {{ $t("bnpl:customer_limit.calculation.button") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
const items = [
  { icon: "money-bill-1", token: "bnpl:customer_limit.calculation.item1" },
  { icon: "lock", token: "bnpl:customer_limit.calculation.item2" },
  { icon: "receipt", token: "bnpl:customer_limit.calculation.item3" },
];

const modal = ref(null);

function open() {
  modal.value.open();
}

defineExpose({ open });
</script>

<style scoped lang="scss">
.calculation-modal {
  :deep(.modal) {
    padding: 20px;
  }
}

.calculation-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
}

.calculation-icon {
  width: 22px;
  min-width: 22px;
  height: 22px;
  color: var(--brandPrimary);
  // the icons are lighter than the text they sit next to, so they are nudged
  // onto the first line instead of the very top of the paragraph
  margin-top: 2px;
}
</style>
